﻿/**
 * This file provides core functionality for using modern ES features on the platform.  It is mostly deprecated
 * since we stopped supporting IE 11.  It does the following:
 *  - Performs tests of several modern ES features and displays an error in the browser console if any fail.
 */
import ecmascriptTestbed from './scm.ecmascript-testbed';

try {
    ecmascriptTestbed.runTestsOnJsDebug();
} catch (error) {
    console.error('One or more ES feature tests failed:', error);
}
